// extracted by mini-css-extract-plugin
var _1 = "t2KR";
var _2 = "t2KY";
var _3 = "t2KX";
var _4 = "t2KS";
var _5 = "t2KV";
var _6 = "t2KS";
var _7 = "t2KV";
var _8 = "t2KW";
var _9 = "t2KU";
var _a = "t2KT";
var _b = "t2KT";
export { _1 as "card", _2 as "errorCode", _3 as "errorCodeContainer", _4 as "no-padding-bottom", _5 as "no-padding-top", _6 as "noPaddingBottom", _7 as "noPaddingTop", _8 as "order", _9 as "title", _a as "title-container", _b as "titleContainer" }
